const freeShippingThreshold = 2900;
const elementId = "free-shipping-progress-bar";

function shopifyFormatCurrency(cents, formatString) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/;

    /**
     * Formats a number of cents into a currency string using the provided
     * precision, thousands separator, and decimal separator.
     * @param number - The number of cents to format.
     * @param precision - The number of decimal places to include.
     * @param thousands - The character to use as the thousands separator.
     * @param decimal - The character to use as the decimal separator.
     * @returns The formatted currency string.
     */
    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = ".",
    ) {
        if (isNaN(number) || number == null) {
            return "0";
        }

        const numString = (number / 100.0).toFixed(precision);
        const parts = numString.split(".");
        const dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands,
        );
        const cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
        switch (placeholder) {
            case "amount":
                // Ex.	1,134.65
                return formatWithDelimiters(cents, 2);
            case "amount_no_decimals":
                // Ex. 1,135
                return formatWithDelimiters(cents, 0);
            case "amount_with_comma_separator":
                // Ex. 1.134,65
                return formatWithDelimiters(cents, 2, ".", ",");
            case "amount_no_decimals_with_comma_separator":
                // Ex. 1.135
                return formatWithDelimiters(cents, 0, ".", ",");
            case "amount_with_apostrophe_separator":
                // Ex. 1'134.65
                return formatWithDelimiters(cents, 2, "'", ".");
            case "amount_no_decimals_with_space_separator":
                // Ex. 1 135
                return formatWithDelimiters(cents, 0, " ");
            case "amount_with_space_separator":
                // 1 134,65
                return formatWithDelimiters(cents, 2, " ", ",");
            case "amount_with_period_and_space_separator":
                // 1 134.65
                return formatWithDelimiters(cents, 2, " ", ".");
            default:
                return match;
        }
    });
}

class CartWatcher {
    init() {
        this.onCartChange().then(() => {
            this.observeCartChanges();
        });
    }

    async fetchCart() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    async onCartChange() {
        const newCart = await this.fetchCart();
        const mainElement = document.getElementById(elementId);
        const availableElement = mainElement.querySelector('.available');
        const inProgressElement = mainElement.querySelector('.in-progress');
        const gapElement = mainElement.querySelector('.free-shipping-gap');
        const currentProgressElement = mainElement.querySelector('.free-shipping-current-progress');
        const gap = freeShippingThreshold - newCart.total_price;
        gapElement.innerHTML = shopifyFormatCurrency(gap, '{{amount_with_comma_separator}}€');
        currentProgressElement.style.width = (newCart.total_price / freeShippingThreshold) * 100 + '%';

        if (gap < 0) {
            availableElement.classList.remove('hidden');
            inProgressElement.classList.add('hidden');
        } else {
            availableElement.classList.add('hidden');
            inProgressElement.classList.remove('hidden');
        }
    }

    observeCartChanges() {
        const cartObserver = new PerformanceObserver((list) => {
            list.getEntries().forEach((entry) => {
                const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
                const isCartChangeRequest = /\/cart\//.test(entry.name);
                if (isValidRequestType && isCartChangeRequest) {
                    this.onCartChange();
                }
            });
        });
        cartObserver.observe({ entryTypes: ["resource"] });
    }
}

const myCartWatcher = new CartWatcher;
myCartWatcher.init();
